import { requestWithToken } from "../helpers/helpers";

const createPlantHealthControl = async (payload) => {
  try {
    const response = await requestWithToken("POST", "/cropDisease", payload);

    return response.data;
  } catch (err) {
    return err.response.data;
  }
};

const fetchCropSubCategories = async () => {
  try {
    const response = await requestWithToken("GET", "/productType/products");

    return response.data;
  } catch (err) {
    return err.response.data;
  }
};

const fetchCropDiseaseCard = async (regionId, startDate, endDate) => {
  try {
    const response = await requestWithToken(
      "GET",
      startDate
        ? `/cropDisease/cropDiseaseCard?regionId=${regionId}&startDate=${startDate}&endDate=${endDate}`
        : `/cropDisease/cropDiseaseCard?regionId=${regionId}`
    );

    return response.data;
  } catch (err) {
    return err.response.data;
  }
};

const fetchCropDiseaseList = async (
  pageNo,
  pageSize,
  regionId,
  startDate,
  endDate
) => {
  try {
    const response = await requestWithToken(
      "GET",
      startDate
        ? `/cropDisease/cropDiseaseList?pageNo=${pageNo}&pageSize=${pageSize}&regionId=${regionId}&startDate=${startDate}&endDate=${endDate}`
        : `/cropDisease/cropDiseaseList?pageNo=${pageNo}&pageSize=${pageSize}&regionId=${regionId}`
    );

    return response.data;
  } catch (err) {
    return err.response.data;
  }
};

export {
  createPlantHealthControl,
  fetchCropSubCategories,
  fetchCropDiseaseCard,
  fetchCropDiseaseList,
};
